/**
 * Interface commune pour les adapters de caméra
 * Architecture pluggable calquée sur ScaleAdapter
 */

export interface CameraFrame {
  dataUrl: string;       // Image en data URL (pour preview)
  base64: string;        // Image en base64 pur (sans préfixe data:)
  mimeType: string;      // Type MIME (image/jpeg)
  width: number;
  height: number;
  timestamp: number;
}

export interface CameraConfig {
  deviceId?: string;     // ID de la webcam USB spécifique
  width?: number;        // Résolution (défaut: 640)
  height?: number;       // Résolution (défaut: 480)
  quality?: number;      // Qualité JPEG 0-1 (défaut: 0.8)
}

export interface CameraAdapter {
  /**
   * Nom de l'adapter
   */
  readonly adapterName: string;

  /**
   * Connecter la caméra (demande permission si nécessaire)
   */
  connect(config?: CameraConfig): Promise<void>;

  /**
   * Déconnecter la caméra
   */
  disconnect(): Promise<void>;

  /**
   * Vérifier si la caméra est connectée
   */
  isConnected(): boolean;

  /**
   * Capturer une frame JPEG
   */
  captureFrame(): Promise<CameraFrame>;

  /**
   * Obtenir le MediaStream pour afficher la preview vidéo
   */
  getStream(): MediaStream | null;
}

export class CameraError extends Error {
  constructor(
    message: string,
    public code: 'NOT_SUPPORTED' | 'PERMISSION_DENIED' | 'NOT_CONNECTED' | 'CAPTURE_ERROR' | 'NO_DEVICE',
    public originalError?: Error,
  ) {
    super(message);
    this.name = 'CameraError';
  }
}
